/*
 * @Author: hjb
 * @Date: 2019-12-19 11:16:33
 * @LastEditTime: 2022-03-17 14:18:18
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\resourceCenter\service\modal\takeDraftModal\takeDraft.js
 * @Description: 取稿模块
 */
'use strict';
angular.module('takeDraftModule', []).controller('fullTakeDraftCtrl', [
    '$scope',
    'isUgc',
    '$q',
    '$timeout',
    '$window',
    '$state',
    '$modalInstance',
    'trsspliceString',
    'trsHttpService',
    'basicParams',
    'isOnlyOne',
    'items',
    'modalDialog',
    'editingCenterService',
    'trsColumnTreeLocationService',
    'directEdit',
    '$filter',
    'globleParamsSet',
    function (
        $scope,
        isUgc,
        $q,
        $timeout,
        $window,
        $state,
        $modalInstance,
        trsspliceString,
        trsHttpService,
        basicParams,
        isOnlyOne,
        items,
        modalDialog,
        editingCenterService,
        trsColumnTreeLocationService,
        directEdit,
        $filter,
        globleParamsSet
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                scalingMenu: true,
                mediasArray: [
                    {
                        mediaName: '我的',
                        mediaValue: 'iwo',
                    },
                    {
                        mediaName: '纸媒',
                        mediaValue: 'newspaper',
                    },
                    {
                        mediaName: '网站',
                        mediaValue: 'website',
                    },
                    {
                        mediaName: '客户端',
                        mediaValue: 'app',
                    },
                    {
                        mediaName: '微信',
                        mediaValue: 'weixin',
                    },
                    {
                        mediaName: '微博',
                        mediaValue: 'weibo',
                    },
                    {
                        mediaName: '抖音',
                        mediaValue: 'tiktok',
                    },
                    {
                        mediaName: '百家号',
                        mediaValue: 'baijiahao',
                    },
                    {
                        mediaName: '企鹅号',
                        mediaValue: 'qiehao',
                    },
                    {
                        mediaName: '头条号',
                        mediaValue: 'toutiao',
                    },
                    {
                        mediaName: '快手',
                        mediaValue: 'kuaishou',
                    }
                ],
                selectedMedia: {},
                isTitleMoreShow: false,
                iwo: {
                    selectedItem: {
                        key: 'iwo',
                        value: '我的',
                        type: 'iwo',
                    },
                },
                staticMediaType: {
                    iwo: -1,
                    app: 1,
                    website: 2,
                    newspaper: 3,
                    weixin: 4,
                    weibo: 5,
                    scapp: '',
                    tiktok: 17,
                    baijiahao: 18,
                    toutiao: 20,
                    qiehao: 19,
                    kuaishou: 25
                },
                editParams: {
                    metadataid: '',
                    chnldocid: '',
                    status: 0,
                    siteid: '',
                    channelid: '',
                    platform: 0,
                    doctype: '',
                },
                editState: {
                    iwo: {
                        1: 'fusionnews',
                        2: 'fusionatlas',
                        4: 'fusionlinkdoc',
                        7: 'fusionvideo',
                        8: 'fusionlive',
                    },
                    Paper: {
                        1: 'newspapertext',
                        2: 'newspaperpic',
                    },
                    Web: {
                        1: 'websitenews',
                        2: 'websiteatlas',
                        4: 'websitelinkdoc',
                        7: 'websitevideo',
                    },
                    MlfApp: {
                        1: 'appnews',
                        2: 'appatlas',
                        4: 'appwebsite',
                        7: 'appvideo',
                        8: 'applive',
                    },
                    WeChat: {
                        1: 'wxeditpage',
                    },
                    tiktok: {
                        3: 'trillnews',
                    },
                    baijiahao: {
                        1: 'baijiahaonews',
                        2: 'baijiahaoatlas',
                        7: 'baijiahaovideo',
                    },
                    kuaibao: {
                        1: 'qiehaonews',
                        2: 'qiehaoatlas',
                        7: 'qiehaovideo',
                    },
                    TouTiao: {
                        1: 'toutiaohaonews',
                        7: 'toutiaohaovideo',
                    },
                    kuaishow: {
                        7: 'kuaishoudraft'
                    }
                },
                accessAuthority: {
                    iwo: false,
                    weixin: false,
                    app: false,
                    website: false,
                    newspaper: false,
                    weibo: false,
                    tiktok: false,
                    baijiahao: false,
                    toutiao: false,
                    qiehao: false,
                    kuaishow: false
                },
                accessibleChannel: 0,
                rightCount: 0,
                isShowWeibo: true,
                directEdit: !!(directEdit == undefined || directEdit == true),
                isNavMove: false,
            };
            $scope.data = {
                selectedWeiboType: '16',
                isOnlyOne: '',
                selectedChannel: [],
                newspaper: {
                    paper: {
                        items: [],
                        selectedItem: {},
                    },
                    dieci: {
                        selectedItem: {},
                    },
                    banmian: {
                        selectedItem: {},
                    },
                    PaperPubDate: '',
                },
                website: {
                    items: [],
                    selectedItem: {},
                    selectedNode: {},
                },
                app: {
                    // 媒立方客户端
                    items: [],
                    selectedItem: {},
                    selectedNode: {},
                },
                weixin: {
                    items: [],
                    selectedNode: {},
                    selectedArray: [],
                },
                weibo: {
                    items: [],
                    selectedNode: {},
                    selectedArray: [],
                },
                scapp: {
                    // 数采客户端
                    items: [],
                    selectedItem: {},
                    selectedNode: {},
                    type: {
                        normal: '频道',
                        local: '地市',
                    },
                },
                result: {
                    toMy: false,
                    Web: [],
                    Paper: [],
                    App: [], // 数采APP
                    MlfApp: [], // 媒立方APP
                    WeChat: [],
                    WeiBo: [],
                    tiktok: [],
                    baijiahao: [],
                    TouTiao: [],
                    kuaibao: [],
                    kuaishou: []
                },
                tiktok: {
                    items: [],
                    selectedNode: {},
                    selectedArray: [],
                },
                baijiahao: {
                    items: [],
                    selectedNode: {},
                    selectedArray: [],
                },
                toutiao: {
                    items: [],
                    selectedNode: {},
                    selectedArray: [],
                },
                qiehao: {
                    items: [],
                    selectedNode: {},
                    selectedArray: [],
                },
                kuaishou: {
                    items: [],
                    selectedNode: {},
                    selectedArray: [],
                },
                conLeftData: [
                    {
                        mediaValue: 'weixin',
                        listName: '微信列表',
                        mediaName: '微信',
                        type: 'WeChat',
                    },
                    {
                        mediaValue: 'weibo',
                        listName: '微博列表',
                        mediaName: '微博',
                        type: 'WeiBo',
                    },
                    {
                        mediaValue: 'tiktok',
                        listName: '抖音列表',
                        mediaName: '抖音',
                        type: 'tiktok',
                    },
                    {
                        mediaValue: 'baijiahao',
                        listName: '百家号列表',
                        mediaName: '百家号',
                        type: 'baijiahao',
                    },
                    {
                        mediaValue: 'qiehao',
                        listName: '企鹅号列表',
                        mediaName: '企鹅号',
                        type: 'kuaibao',
                    },
                    {
                        mediaValue: 'toutiao',
                        listName: '头条号列表',
                        mediaName: '头条号',
                        type: 'TouTiao',
                    },
                    {
                        mediaValue: 'kuaishou',
                        listName: '快手列表',
                        mediaName: '快手',
                        type: 'kuaishou'
                    },
                ],
                trackData: [
                    {
                        trackName: '我的',
                        type: 'iwo',
                        accessName: 'iwo',
                        isShow: true,
                    },
                    {
                        trackName: '纸媒',
                        type: 'Paper',
                        accessName: 'newspaper',
                        isShow: true,
                    },
                    {
                        trackName: '网站',
                        type: 'Web',
                        accessName: 'website',
                        isShow: true,
                    },
                    {
                        trackName: '客户端',
                        type: 'MlfApp',
                        accessName: 'app',
                        isShow: true,
                    },
                    {
                        trackName: '微信',
                        type: 'WeChat',
                        accessName: 'weixin',
                        isShow: true,
                    },
                    {
                        trackName: '微博',
                        type: 'WeiBo',
                        accessName: 'weibo',
                        isShow: true,
                    },
                    {
                        trackName: '抖音',
                        type: 'tiktok',
                        accessName: 'tiktok',
                        isShow: true,
                    },
                    {
                        trackName: '百家号',
                        type: 'baijiahao',
                        accessName: 'baijiahao',
                        isShow: true,
                    },
                    {
                        trackName: '企鹅号',
                        type: 'kuaibao',
                        accessName: 'qiehao',
                        isShow: true,
                    },
                    {
                        trackName: '头条号',
                        type: 'TouTiao',
                        accessName: 'toutiao',
                        isShow: true,
                    },
                    {
                        trackName: '快手',
                        type: 'kuaishou',
                        accessName: 'kuaishou',
                        isShow: true,
                    },
                ],
            };
            $scope.navStyle = {
                'margin-left': '0px',
            };
            // 网站、app树配置开始
            $scope.treeOptions = {
                nodeChildren: 'CHILDREN',
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: 'a1',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'a3',
                    iCollapsed: 'a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'take-draft-tree-label-sel',
                },
                isLeaf: function (node) {
                    return node.HASCHILDREN === 'false'; // node.CHILDREN == undefined && node.CHANNELID != undefined;
                },
            };
            // 数采app树配置开始
            $scope.appTreeOptions = {
                nodeChildren: 'ZONE_COLUMNS',
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: 'a1',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'a3',
                    iCollapsed: 'a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'take-draft-tree-label-sel',
                },
                isLeaf: function (node) {
                    return node.ZONE_COLUMNS == undefined;
                },
            };
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            // $scope.status.selectedMedia = $scope.status.mediasArray[0];
            $scope.data.isOnlyOne = isOnlyOne;
            getSystemTime();
            getAccessAuthority().then(function () {
                calcuAccessbleChannel();
            });
        }

        /**
         * [calcuAccessbleChannel description] 计算有权限访问渠道数量
         * @return  {[type]}  [return description]
         */
        function calcuAccessbleChannel() {
            var count = 0;
            for (let i in $scope.status.accessAuthority) {
                if ($scope.status.accessAuthority[i] === true) {
                    count++;
                }
            }
            if (!$scope.status.isShowWeibo) {
                count--;
            }
            $scope.status.accessibleChannel = count;
        }

        /**
         * [showWeibo description] 是否展示微博渠道
         * @return {[type]} [description]
         */
        function showWeibo() {
            if (!items || !hasFusionWeibo()) {
                $scope.status.mediasArray.splice(5, 1);
                $scope.status.isShowWeibo = false;
            }

            /**
             * [hasFusionWeibo description] 是否都是融合微博
             * @return {Boolean} [description]
             */
            function hasFusionWeibo() {
                return items.every(function (item, index) {
                    return (
                        item.relatedMedias &&
                        item.relatedMedias instanceof Array &&
                        item.relatedMedias.some(function (_item, _index) {
                            return _item.MEDIATYPE == 5;
                        })
                    );
                });
            }
        }

        /**
         * [getAccessAuthority description]判断渠道下权限
         * @return {[type]} [description]
         */
        function getAccessAuthority() {
            var deferred = $q.defer();
            var docType = angular.isDefined(items) && angular.isArray(items) && items.length ? items[0].DOCTYPEID || items[0].doctypeId || items[0].DOC_TYPE || items[0].docType : undefined;
            var trench;
            editingCenterService.getPermissions(docType, false).then(function (data) {
                for (var i in data) {
                    if (!trench) {
                        trench = i;
                    }
                    $scope.status.accessAuthority[i] = true;
                }
                for (var j = 0; j < $scope.status.mediasArray.length; j++) { // 由于iwo没法匹配所有类型稿件（音频、链接等）所以需要根据权限获取默认选中的渠道
                    if ($scope.status.mediasArray[j].mediaValue === trench) {
                        $scope.status.selectedMedia = $scope.status.mediasArray[j];
                        $scope.setCurrMedia($scope.status.selectedMedia);
                        break;
                    }
                }
                deferred.resolve($scope.status.accessAuthority);
            });
            return deferred.promise;
        }

        // 关闭窗口
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        // 展开子树
        $scope.showToggle = function (node, platform) {
            if (node.HASCHILDREN === 'false' || (angular.isDefined(node.CHILDREN) && node.CHILDREN.length > 0)) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyByChnl',
                ChannelId: node.CHANNELID,
                platform: platform
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                node.CHILDREN = data.CHILDREN;
            });
        };

        /**
         * [getSystemTime description] 查询当前系统时间
         * @return  {[type]}  [return description]
         */
        function getSystemTime() {
            globleParamsSet.getServerTime().then((data) => {
                var timeStamp = data.LASTOPERTIME.replace(/-/g, '/');
                var timeSta = Number($filter('date')(new Date(), 'HH'));
                var PaperPubDate = new Date(Date.parse(timeStamp));
                if (timeSta > 8) {
                    PaperPubDate = PaperPubDate.setDate(PaperPubDate.getDate() + 1);
                } else {
                    PaperPubDate = PaperPubDate.setDate(PaperPubDate.getDate());
                }
                $scope.data.newspaper.PaperPubDate = PaperPubDate;
            });
        }

        /**
         * [setCurrMedia description] 点击渠道加载对应数据
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.setCurrMedia = function (item) {
            $scope.status.selectedMedia = item;
            var temp = item.mediaValue.replace(/(\w)/, function (v) {
                return v.toUpperCase();
            }); // 首字母大写
            eval('query' + temp + '()');
        };

        /**
         * [queryIwo description] 获取IWO
         * @return  {[type]}  [return description]
         */
        function queryIwo() { }

        /**
         * [queryNewspaper description]获取报纸列表
         * @return {[type]} [description]
         */
        function queryNewspaper() {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryPagers',
            };
            if ($scope.data.newspaper.paper.items.length > 0) {
                return;
            }
            $scope.loadingNewspaper = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.newspaper.paper.items = data;
                queryNewspaperDieci(data[0]);
            });
        }

        /**
         * [queryNewspaperDieci description] 查询制定报纸叠次
         * @param  {[type]} item [description] 报纸
         * @return {[type]}      [description]
         */
        $scope.queryNewspaperDieci = function (item) {
            queryNewspaperDieci(item);
        };

        /**
         * [queryNewspaperDieci description] 查询制定报纸叠次具体方法
         * @param  {[type]} item [description] 报纸
         * @return {[type]}      [description]
         */
        function queryNewspaperDieci(item) {
            $scope.data.newspaper.paper.selectedItem = item;
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryDieCis',
                PaperId: item.SITEID,
            };
            if (!!item.CHILDREN) {
                $scope.data.newspaper.dieci.selectedItem = item.CHILDREN[0];
                return;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                item.CHILDREN = data;
                $scope.data.newspaper.dieci.selectedItem = data[0];
                queryNewspaperBanmian($scope.data.newspaper.dieci.selectedItem);
            });
        }

        /**
         *[getSuggestions description]搜索栏目
         * @param  {[type]}channelname  [description] 输入栏目名称
         * return {[type]}   null  [description]
         */
        var promise;
        $scope.getSuggestions = function (channelName, type) {
            if (channelName === '') {
                return;
            }
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            var siteid = type == 'website' ? $scope.data.website.selectedItem.SITEID : $scope.data.app.selectedItem.SITEID;
            promise = $timeout(function () {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryRightClassifyByName',
                    ChannelName: channelName,
                    SiteId: siteid,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    return data;
                });
            }, 500);
            return promise;
        };
        $scope.$watch('data.channelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                // 初始化树数据
                queryWebsiteTreeBySiteid();
                // 清空树展开
                $scope.webExpandedTest = [];
                // 重新定位树展开位置
                // getPositionData(newValue.CHANNELID);
                trsColumnTreeLocationService.columnTreeLocation(
                    1,
                    newValue.CHANNELID,
                    $scope.data.website.selectedItem.TREE,
                    $scope.data.selectedNode,
                    $scope.webExpandedTest,
                    function (tree, array, selectedNode) {
                        delete $scope.data.website.selectedItem.TREE;
                        $scope.data.website.selectedItem.TREE = tree;
                        $scope.data.website.selectedNode = selectedNode;
                        $scope.addWebSiteToSelectedChnl($scope.data.website.selectedNode);
                    }
                );
            }
        });
        $scope.$watch('data.appChannelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                // 初始化树数据
                queryAppTreeBySiteid();
                // 清空树展开
                $scope.appExpandedTest = [];
                // 重新定位树展开位置
                // getPositionData(newValue.CHANNELID);
                trsColumnTreeLocationService.columnTreeLocation(
                    7,
                    newValue.CHANNELID,
                    $scope.data.app.selectedItem.TREE,
                    $scope.data.appSelectedNode,
                    $scope.appExpandedTest,
                    function (tree, array, selectedNode) {
                        delete $scope.data.app.selectedItem.TREE;
                        $scope.data.app.selectedItem.TREE = tree;
                        $scope.data.app.selectedNode = selectedNode;
                        $scope.addAppToSelectedChnl($scope.data.app.selectedNode);
                    }
                );
            }
        });

        /**
         * [queryNewspaperBanmian description] 查询报纸的版面
         * @param  {[type]} item [description] 叠次
         * @return {[type]}      [description]
         */
        $scope.queryNewspaperBanmian = function (item) {
            queryNewspaperBanmian(item);
        };

        /**
         * [queryNewspaperBanmian description] 查询报纸的版面具体方法
         * @param  {[type]} item [description] 叠次
         * @return {[type]}      [description]
         */
        function queryNewspaperBanmian(item) {
            $scope.data.newspaper.dieci.selectedItem = item;
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryCaiBianBanMians',
                PaperId: $scope.data.newspaper.paper.selectedItem.SITEID,
                DieCiId: item.CHANNELID,
            };
            if (!!item.CHILDREN) {
                return;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                item.CHILDREN = data;
            });
        }

        /**
         * [setNewspaperBanmianStatus description] 报纸栏目选择后加入到已选
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.setNewspaperBanmianStatus = function (item) {
            if ($scope.data.newspaper.banmian.selectedItem[$scope.data.newspaper.paper.selectedItem.SITEID] == item) {
                delete $scope.data.newspaper.banmian.selectedItem[$scope.data.newspaper.paper.selectedItem.SITEID];
            } else {
                $scope.data.newspaper.banmian.selectedItem[$scope.data.newspaper.paper.selectedItem.SITEID] = item;
            }
            var site = $scope.data.newspaper.paper.selectedItem;
            var newspaperPath =
                $scope.status.mediasArray[1].mediaName +
                '-' +
                site.SITEDESC +
                '-' +
                $scope.data.newspaper.dieci.selectedItem.CHNLDESC +
                '-' +
                item.CHNLDESC;
            var newspaperSelected = {
                key: site.SITEID,
                value: newspaperPath,
                type: 'Paper',
                id: item.CHANNELID,
            };
            refreshSelectedChnl(newspaperSelected, item.CHANNELID);
        };

        $scope.queryTreeBySite = function (item) {
            $scope.data.website.selectedItem = item[0].CHILDREN;
            queryTreeBySite();
        };

        /**
         * [queryTreeBySite description]
         * @return  {[type]}  [return description]
         */
        function queryTreeBySite() {
            var params = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'queryClassifyBySite',
                SiteId: $scope.data.website.selectedItem.SITEID,
                platform: 1
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.website.treeData = [data];
            });
        }

        /**
         * [changeRadioStatus description]切换iwo取稿到个人稿库选中状态并加入到已选集合
         * @return {[type]} [description]
         */
        $scope.changeRadioStatus = function () {
            var index = $scope.data.selectedChannel.indexOf($scope.status.iwo.selectedItem);
            if (index < 0) {
                $scope.data.selectedChannel.push($scope.status.iwo.selectedItem);
            } else {
                $scope.data.selectedChannel.splice(index, 1);
            }
            $scope.data.result.toMy = !$scope.data.result.toMy;
        };
        $scope.determineItemInSelectedChnl = function (key) {
            return queryIndexInSelectedChnl(key) > -1;
        };

        /**
         * [queryIndexInSelectedChnl description] 按照key 查询已选结合中下标[{key:'',value:''}]
         * @param   {[type]}  key  [key description]
         * @param   {[type]}  id   [id description]
         * @return  {[type]}       [return description]
         */
        function queryIndexInSelectedChnl(key, id) {
            for (var i in $scope.data.selectedChannel) {
                if (
                    key != 'weixin' &&
                    key != 'weibo' &&
                    key != 'baijiahao' &&
                    key != 'qiehao' &&
                    key != 'tiktok' &&
                    key != 'toutiao' &&
                    key !== 'kuaishou' &&
                    $scope.data.selectedChannel[i].key == key
                ) {
                    return i;
                }
                if (
                    (key == 'weixin' || key == 'weibo' || key == 'baijiahao' || key == 'qiehao' || key == 'tiktok' || key == 'toutiao' || key == 'kuaishou') &&
                    $scope.data.selectedChannel[i].id == id && $scope.data.selectedChannel[i].key == key
                ) {
                    return i;
                }
            }
            return -1;
        }

        /**
         * [refreshSelectedChnl description] 更新已选栏目，寻找该KEY，如果找到则替换value,没有找到则加入,同时更新对应渠道ID
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  id    [id description]
         * @return  {[type]}        [return description]
         */
        function refreshSelectedChnl(item, id) {
            var index = queryIndexInSelectedChnl(item.key, item.id);
            if (index > -1) {
                if ($scope.data.selectedChannel[index].value == item.value) {
                    $scope.data.selectedChannel.splice(index, 1);
                    return;
                }
                $scope.data.selectedChannel[index].value = item.value;
                $scope.data.selectedChannel[index].id = item.id;
            } else {
                $scope.data.selectedChannel.push(item);
            }
        }

        /**
         * [removeIwoChanel description] 从已选结集合中删除改对象
         * @param   {[type]}  index  [index description]
         * @param   {[type]}  item   [item description]
         * @return  {[type]}         [return description]
         */
        $scope.removeIwoChanel = function (index, item) {
            if ($scope.data.selectedChannel[index].key == 'iwo') {
                $scope.data.result.toMy = false;
            }
            if (angular.isDefined(item) && $scope.data.weixin.selectedArray.indexOf(item.id) >= 0) {
                $scope.data.weixin.selectedArray.splice($scope.data.weixin.selectedArray.indexOf(item.id), 1);
            }
            if (angular.isDefined(item) && $scope.data.weibo.selectedArray.indexOf(item.id) >= 0) {
                $scope.data.weibo.selectedArray.splice($scope.data.weibo.selectedArray.indexOf(item.id), 1);
            }
            $scope.data.selectedChannel.splice(index, 1);
            delSelectedArrFn(item);
        };

        /**
         * [delSelectedArrFn description] 删除网站和APP中的选中项
         * @param  {[type]} item [description] 当前对象
         * @return {[type]}      [description]
         */
        function delSelectedArrFn(item) {
            switch (item.type) {
                case 'MlfApp':
                    delete $scope.data.app.selectedNode[item.key];
                    break;
                case 'Web':
                    delete $scope.data.website.selectedNode[item.key];
                    break;
            }
        }

        /**
         * [queryWebsite description]查询网站站点列表
         * @return {[type]} [description]
         */
        function queryWebsite() {
            if ($scope.data.website.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.website,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.website.items = data.DATA;
                $scope.data.website.selectedItem = data.DATA[0];
                setSelectedWebsite(data.DATA[0]);
            });
        }

        /**
         * [queryApp description]查询APP站点列表
         * @return {[type]} [description]
         */
        function queryApp() {
            if ($scope.data.app.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.app,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.app.items = data.DATA;
                $scope.data.app.selectedItem = data.DATA[0];
                if ($scope.data.app.selectedItem.SITETYPE == '-1') {
                    queryScapp();
                    return;
                }
                queryAppTreeBySiteid();
            });
        }

        /**
         * [queryApp description]查询微信站点列表
         * @return {[type]} [description]
         */
        function queryWeixin() {
            if ($scope.data.weixin.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.weixin,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.weixin.items = data.DATA;
            });
        }

        /**
         * [queryApp description]查询微信站点列表
         * @return {[type]} [description]
         */
        function queryWeibo() {
            if ($scope.data.weibo.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.weibo,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHNLDESC = item.ACCOUNTNAME;
                    item.CHANNELID = item.ACCOUNTID;
                });
                $scope.data.weibo.items = data.DATA;
            });
        }

        /**
         * [queryApp description]查询抖音用户列表
         * @return {[type]} [description]
         */
        function queryTiktok() {
            if ($scope.data.tiktok.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.tiktok,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHNLDESC = item.ACCOUNTNAME;
                    item.CHANNELID = item.DOUYINACCOUNTID;
                });
                $scope.data.tiktok.items = data.DATA;
            });
        }

        /**
         * [queryKuaishou description]查询抖音用户列表
         * @return {[type]} [description]
         */
        function queryKuaishou() {
            if ($scope.data.kuaishou.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.kuaishou,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHNLDESC = item.ACCOUNTNAME;
                    item.CHANNELID = item.ACCOUNTID;
                });
                $scope.data.kuaishou.items = data.DATA;
            });
        }

        /**
         * [queryApp description]查询百家号用户列表
         * @return {[type]} [description]
         */
        function queryBaijiahao() {
            if ($scope.data.baijiahao.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.baijiahao,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHNLDESC = item.ACCOUNTNAME;
                    item.CHANNELID = item.BAIJIAHAOACCOUNTID;
                });
                $scope.data.baijiahao.items = data.DATA;
            });
        }

        /**
         * [queryApp description]查询百家号用户列表
         * @return {[type]} [description]
         */
        function queryToutiao() {
            if ($scope.data.toutiao.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.toutiao,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHNLDESC = item.CHNLNAME;
                    item.CHANNELID = item.CHANNELID;
                });
                $scope.data.toutiao.items = data.DATA;
            });
        }

        /**
         * [queryApp description]查询百家号用户列表
         * @return {[type]} [description]
         */
        function queryQiehao() {
            if ($scope.data.qiehao.items.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: $scope.status.staticMediaType.qiehao,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHNLDESC = item.ACCOUNTNAME;
                    item.CHANNELID = item.ACCOUNTID;
                });
                $scope.data.qiehao.items = data.DATA;
            });
        }

        /**
         * [setSelectedApp description] 选择APP内的站点
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.setSelectedApp = function (item) {
            $scope.data.app.selectedItem = item;
            if (item.SITETYPE == '-1') {
                queryScapp();
                return;
            }
            queryAppTreeBySiteid();
        };

        /**
         * [queryAppTreeBySiteid description] 根据站点查询APP渠道栏目
         * @return  {[type]}  [return description]
         */
        function queryAppTreeBySiteid() {
            if (!!$scope.data.app.selectedItem.TREE) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: $scope.data.app.selectedItem.SITEID,
                platform: 7,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.app.selectedItem.TREE = data;
            });
        }

        /**
         * [setSelectedWebsite description] 选择网站内的站点
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.setSelectedWebsite = function (item) {
            setSelectedWebsite(item);
        };

        /**
         * [setSelectedWebsite description] 选择网站内的站点实体方法
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function setSelectedWebsite(item) {
            $scope.data.website.selectedItem = item;
            queryWebsiteTreeBySiteid();
        }

        /**
         * [queryWebsiteTreeBySiteid description]查询当前已选站点的栏目树
         * @return {[type]} [description]
         */
        function queryWebsiteTreeBySiteid() {
            if (!!$scope.data.website.selectedItem.TREE) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: $scope.data.website.selectedItem.SITEID,
                platform: 1,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.website.selectedItem.TREE = data;
            });
        }

        /**
         * [addWebSiteToSelectedChnl description] 点击网站栏目节点，刷新已选栏目集合
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addWebSiteToSelectedChnl = function (node) {
            if (!node.CHNLDESC) {
                return false;
            }
            if ($scope.data.website.selectedNode[node.SITEID] == node) {
                delete $scope.data.website.selectedNode[node.SITEID];
            } else {
                $scope.data.website.selectedNode[node.SITEID] = node;
            }
            var websitePath = {
                key: node.SITEID,
                value: $scope.status.mediasArray[2].mediaName + '-' + $scope.data.website.selectedItem.SITEDESC + '-' + node.CHNLDESC,
                type: 'Web',
                id: node.CHANNELID,
            };
            refreshSelectedChnl(websitePath, node.CHANNELID);
        };

        /**
         * [addAppToSelectedChnl description] 点击App栏目节点，刷新已选栏目集合
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addAppToSelectedChnl = function (node) {
            if (!node.CHNLDESC) {
                return false;
            }
            var isChecked = $scope.data.app.selectedNode[node.SITEID] == node;
            appChannelAvailable(node, isChecked).then(function () {
                if (isChecked) {
                    delete $scope.data.app.selectedNode[node.SITEID];
                } else {
                    $scope.data.app.selectedNode[node.SITEID] = node;
                }
                var appPath = {
                    key: node.SITEID,
                    value: $scope.status.mediasArray[3].mediaName + '-' + $scope.data.app.selectedItem.SITEDESC + '-' + node.CHNLDESC,
                    type: 'MlfApp',
                    id: node.CHANNELID,
                };
                refreshSelectedChnl(appPath, node.CHANNELID);
            });
        };

        /**
         * [appChannelAvailable description] APP栏目是否允许该类型稿件创建
         * @param {obejct} [node] [description] 所选节点
         * @param {Boolean} [isChecked] [description] 是否选中，取消选中不需要检验
         * @return {[type]} [description]
         */
        function appChannelAvailable(node, isChecked) {
            var defer = $q.defer();
            if (isUgc) {
                // ugc稿件不做校验
                defer.resolve();
            } else if (isChecked) {
                defer.resolve();
            } else if (angular.isUndefined(items)) {
                defer.resolve();
            } else {
                if (angular.isUndefined(items[0].METADATAID)) {
                    defer.resolve(); // 大数据取稿没有METADATAID 不做校验
                    return defer.promise;
                }
                var params = {
                    serviceid: 'mlf_appoper',
                    methodname: 'checkCanSubmitToChannel',
                    metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                    channelId: node.CHANNELID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve();
                });
            }
            return defer.promise;
        }

        /**
         * [addWeixinToSelectedChnl description] 点击微信栏目节点，刷新已选栏目集合
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addWeixinToSelectedChnl = function (node) {
            if ($scope.data.weixin.selectedArray.indexOf(node.CHANNELID) < 0) {
                $scope.data.weixin.selectedArray.push(node.CHANNELID);
                $scope.data.weixin.selectedNode = node;
                if (!node.CHNLDESC) {
                    return false;
                }
                var weixinPath = {
                    key: 'weixin',
                    value: $scope.status.mediasArray[4].mediaName + '-' + node.CHNLDESC,
                    type: 'WeChat',
                    id: node.CHANNELID,
                };
                refreshSelectedChnl(weixinPath, node.CHANNELID);
            } else {
                $scope.data.weixin.selectedArray.splice($scope.data.weixin.selectedArray.indexOf(node.CHANNELID), 1);
                angular.forEach($scope.data.selectedChannel, function (data, index) {
                    if (data.id == node.CHANNELID) {
                        $scope.removeIwoChanel(index);
                    }
                });
            }
        };

        /**
         * [addToSelectedChnl description] 点击栏目节点--通用，刷新已选栏目集合
         * @param   {[type]}  site  [site description]
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addToSelectedChnl = function (site, node) {
            node.CHANNELID = node.CHANNELID || node.KUAIBAOACCOUNTID;
            if ($scope.data[site.mediaValue].selectedArray.indexOf(node.CHANNELID) < 0) {
                $scope.data[site.mediaValue].selectedArray.push(node.CHANNELID);
                $scope.data[site.mediaValue].selectedNode = node;
                if (!node.CHNLDESC) {
                    return false;
                }
                var addPath = {
                    key: site.mediaValue,
                    value: site.mediaName + '-' + node.CHNLDESC,
                    type: site.type,
                    id: node.CHANNELID,
                };
                refreshSelectedChnl(addPath, node.CHANNELID);
            } else {
                $scope.data[site.mediaValue].selectedArray.splice($scope.data[site.mediaValue].selectedArray.indexOf(node.CHANNELID), 1);
                angular.forEach($scope.data.selectedChannel, function (data, index) {
                    if (data.id == node.CHANNELID && data.key == site.mediaValue) {
                        $scope.removeIwoChanel(index);
                    }
                });
            }
        };

        /**
         * [addWeiboToSelectedChnl description] 点击微博栏目节点，刷新已选栏目集合
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addWeiboToSelectedChnl = function (node) {
            if ($scope.data.weibo.selectedArray.indexOf(node.CHANNELID) < 0) {
                $scope.data.weibo.selectedArray.push(node.CHANNELID);
                $scope.data.weibo.selectedNode = node;
                if (!node.CHNLDESC) {
                    return false;
                }
                var weiboPath = {
                    key: 'weibo',
                    value: $scope.status.mediasArray[5].mediaName + '-' + node.CHNLDESC,
                    type: 'WeiBo',
                    id: node.CHANNELID,
                };
                refreshSelectedChnl(weiboPath, node.CHANNELID);
            } else {
                $scope.data.weibo.selectedArray.splice($scope.data.weibo.selectedArray.indexOf(node.CHANNELID), 1);
                angular.forEach($scope.data.selectedChannel, function (data, index) {
                    if (data.id == node.CHANNELID) {
                        $scope.removeIwoChanel(index);
                    }
                });
            }
        };

        /**
         * [addDouyinToSelectedChnl description] 点击抖音用户节点，刷新已选栏目集合
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addDouyinToSelectedChnl = function (node) {
            if ($scope.data.tiktok.selectedArray.indexOf(node.CHANNELID) < 0) {
                $scope.data.tiktok.selectedArray.push(node.CHANNELID);
                $scope.data.tiktok.selectedNode = node;
                if (!node.CHNLDESC) {
                    return false;
                }
                var douyinPath = {
                    key: 'tiktok',
                    value: '抖音' + '-' + node.CHNLDESC,
                    type: 'tiktok',
                    id: node.CHANNELID,
                };
                refreshSelectedChnl(douyinPath, node.CHANNELID);
            } else {
                $scope.data.tiktok.selectedArray.splice($scope.data.tiktok.selectedArray.indexOf(node.CHANNELID), 1);
                angular.forEach($scope.data.selectedChannel, function (data, index) {
                    if (data.id == node.CHANNELID) {
                        $scope.removeIwoChanel(index);
                    }
                });
            }
        };

        /**
         * [addKuaishouToSelectedChnl description] 点击抖音用户节点，刷新已选栏目集合
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addKuaishouToSelectedChnl = function (node) {
            if ($scope.data.kuaishou.selectedArray.indexOf(node.CHANNELID) < 0) {
                $scope.data.kuaishou.selectedArray.push(node.CHANNELID);
                $scope.data.kuaishou.selectedNode = node;
                if (!node.CHNLDESC) {
                    return false;
                }
                var kuaishouPath = {
                    key: 'kuaishou',
                    value: '快手-' + node.CHNLDESC,
                    type: 'kuaishou',
                    id: node.CHANNELID,
                };
                refreshSelectedChnl(kuaishouPath, node.CHANNELID);
            } else {
                $scope.data.kuaishou.selectedArray.splice($scope.data.kuaishou.selectedArray.indexOf(node.CHANNELID), 1);
                angular.forEach($scope.data.selectedChannel, function (data, index) {
                    if (data.id == node.CHANNELID) {
                        $scope.removeIwoChanel(index);
                    }
                });
            }
        };

        /**
         * [addBaijiahaoToSelectedChnl description] 点击抖音用户节点，刷新已选栏目集合
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.addBaijiahaoToSelectedChnl = function (node) {
            if ($scope.data.baijiahao.selectedArray.indexOf(node.CHANNELID) < 0) {
                $scope.data.baijiahao.selectedArray.push(node.CHANNELID);
                $scope.data.baijiahao.selectedNode = node;
                if (!node.CHNLDESC) {
                    return false;
                }
                var baijiahaoPath = {
                    key: 'baijiahao',
                    value: '百家号' + '-' + node.CHNLDESC,
                    type: 'baijiahao',
                    id: node.CHANNELID,
                };
                refreshSelectedChnl(baijiahaoPath, node.CHANNELID);
            } else {
                $scope.data.baijiahao.selectedArray.splice($scope.data.baijiahao.selectedArray.indexOf(node.CHANNELID), 1);
                angular.forEach($scope.data.selectedChannel, function (data, index) {
                    if (data.id == node.CHANNELID) {
                        $scope.removeIwoChanel(index);
                    }
                });
            }
        };

        /**
         * [queryScapp description]查询数采APP栏目树，并构造左侧列表
         * @return {[type]} [description]
         */
        function queryScapp() {
            var params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getColumns',
            };
            if ($scope.data.scapp.items.length > 0) {
                return;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                for (var i in data) {
                    data[i].NAME = $scope.data.scapp.type[data[i].COLUMN_TYPE];
                    data[i].ZONE_COLUMNS = data[i].COLUMNS;
                    delete data[i].COLUMNS;
                }
                $scope.data.scapp.items = data;
            });
        }
        $scope.addScappToSelectedChnl = function (node) {
            var tempItem = $scope.data.app.selectedItem;
            $scope.data.scapp.selectedNode = node;
            var scappPath = {
                key: 'scapp',
                value: 'APP-' + $scope.data.app.selectedItem.SITEDESC + '-' + (node.NAME ? node.NAME : node.ZONE_NAME),
                type: 'App',
                id: node.ID,
            };
            refreshSelectedChnl(scappPath, node.ID);
        };
        $scope.editLater = function () {
            saveDraft().then(function (data) {
                modalDialog.alertType('取稿成功！', '', 'success', false, function () {
                    $modalInstance.close(data);
                });
            });
        };

        /**
         * [editNow description] 直接编辑
         * @return  {[type]}  [return description]
         */
        $scope.editNow = function () {
            saveDraft().then(function (data) {
                setEditParams(data).then(function (data) {
                    routerTopreview(data);
                });
            });
        };

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [fusionEditorParams description] 处理iwo融合编辑器参数
         * @param   {[type]}  iwometadataid  [iwometadataid description]
         * @param   {[type]}  iwochnldocid   [iwochnldocid description]
         * @param   {[type]}  doctype        [doctype description]
         * @return  {[type]}                 [return description]
         */
        function fusionEditorParams(iwometadataid, iwochnldocid, doctype) {
            var deffer = $q.defer();
            var routerParams = {
                iwoplatform: 1,
                wzplatform: 0,
                appplatform: 0,
                newspapertype: 2,
                weixinplatform: 0,
                iwometadataid: iwometadataid,
                iwochnldocid: iwochnldocid,
            };
            getRelatedMediaIds(doctype).then(function (relatedData) {
                angular.forEach(relatedData, function (value, key) {
                    if (value.MEDIATYPE == '1') {
                        routerParams.appsiteid = value.SITEID;
                        routerParams.appchannelid = value.CHANNELID;
                    } else if (value.MEDIATYPE == '2') {
                        routerParams.wzsiteid = value.SITEID;
                        routerParams.wzchannelid = value.CHANNELID;
                    } else if (value.MEDIATYPE == '3') {
                        routerParams.paperid = value.CHANNELID;
                    }
                });
                getBindingMediaIds(iwometadataid).then(function (bingdingData) {
                    angular.forEach(bingdingData, function (value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID;
                            routerParams.papermetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '4') {
                            routerParams.wxchannelid = value.CHANNELID;
                            routerParams.wxchnldocid = value.CHNLDOCID;
                            routerParams.wxmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '5') {
                            routerParams.wbmetadataid = value.VIRTUALDOCID;
                        }
                    });
                    deffer.resolve(routerParams);
                });
            });
            return deffer.promise;
        }

        /**
         * [getRelatedMediaIds description] 获取关联渠道的相关id
         * @param {[type]} [doctype] [description] 稿件类型
         * @return {[type]} [description]
         */
        function getRelatedMediaIds(doctype) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'getMediaTypesByDocType',
                doctype: doctype,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [setEditParams description] 设置编辑参数
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function setEditParams(data) {
            var deffer = $q.defer();
            var trench, key; // trench表示是老渠道，key是指向每个渠道数据的标识
            switch ($scope.data.selectedChannel[0].type) {
                case 'iwo':
                    trench = 'iwo';
                    fusionEditorParams(data.REPORTS[0].METADATAID, data.REPORTS[0].CHNLDOCID, $scope.status.editParams.doctype).then(function (
                        params
                    ) {
                        $scope.status.editParams = params;
                        deffer.resolve(data);
                    });
                    break;
                case 'Web':
                    trench = 'wz';
                    $scope.status.editParams.wzchannelid = $scope.data.website.selectedNode[$scope.data.website.selectedItem.SITEID].CHANNELID;
                    break;
                case 'MlfApp':
                    trench = 'app';
                    $scope.status.editParams.appchannelid = $scope.data.app.selectedNode[$scope.data.app.selectedItem.SITEID].CHANNELID;
                    break;
                case 'Paper':
                    $scope.status.editParams.papermetadataid = data.REPORTS[0].METADATAID;
                    $scope.status.editParams.newspapertype = 2;
                    $scope.status.editParams.paperid = $scope.data.selectedChannel[0].key;
                    deffer.resolve(data);
                    break;
                case 'WeChat':
                    trench = 'wx';
                    $scope.status.editParams.wxchannelid = $scope.data.selectedChannel[0].id;
                    break;
                case 'kuaibao':
                    key = 'qiehao';
                    break;
                case 'tiktok':
                    key = 'tiktok';
                    break;
                case 'baijiahao':
                    key = 'baijiahao';
                    break;
                case 'TouTiao':
                    key = 'toutiao';
                    break;
                case 'kuaishou':
                    key = 'kuaishou';
                    break;
            }
            if (trench) {
                if (trench !== 'iwo') {
                    $scope.status.editParams[trench + 'chnldocid'] = data.REPORTS[0].CHNLDOCID;
                    $scope.status.editParams[trench + 'metadataid'] = data.REPORTS[0].METADATAID;
                    $scope.status.editParams[trench + 'platform'] = 0;
                    $scope.status.editParams[trench + 'siteid'] = $scope.data.selectedChannel[0].key;
                    deffer.resolve(data);
                }
            } else {
                if (key === 'toutiao') {
                    $scope.status.editParams[key + 'platform'] = 0;
                    key = '';
                }
                $scope.status.editParams[key + 'articleid'] = data.REPORTS[0].METADATAID;
                $scope.status.editParams[key + 'account'] = $scope.data.selectedChannel[0].id;
                $scope.status.editParams[key + 'platform'] = 0;
                deffer.resolve(data);
            }

            return deffer.promise;
        }

        /**
         * [routerTopreview description] 跳转预览
         * @param   {[object]}  result  [result description] 取稿后的返回值
         * @return  {[type]}            [return description]
         */
        function routerTopreview(result) {
            var params = {
                serviceid: 'mlf_paperset',
                methodname: 'findPaperById',
                SiteId: $scope.data.newspaper.paper.selectedItem.SITEID,
            };
            if (result.ISSUCCESS == 'false') {
                $modalInstance.close();
            } else if (!$scope.data.newspaper.paper.selectedItem.SITEID) {
                $window.open(
                    $state.href($scope.status.editState[$scope.data.selectedChannel[0].type][result.REPORTS[0].DOCTYPE], $scope.status.editParams),
                    '_blank'
                );
                $modalInstance.close();
            } else {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.status.editParams.newspapertype = data.ISDUOJISHEN == '0' ? 2 : 1;
                    $window.open(
                        $state.href(
                            $scope.status.editState[$scope.data.selectedChannel[0].type][result.REPORTS[0].DOCTYPE],
                            $scope.status.editParams
                        ),
                        '_blank'
                    );
                    $modalInstance.close();
                });
            }
        }

        /**
         * [saveDraft description] 保存稿件
         * @return  {[type]}  [return description]
         */
        function saveDraft() {
            var deferred = $q.defer();
            var pubDate = new Date($scope.data.newspaper.PaperPubDate);
            pubDate = pubDate.getFullYear() + '-' + (pubDate.getMonth() + 1) + '-' + pubDate.getDate();
            var params = {
                PaperPubDate: pubDate,
            };
            params = angular.extend(params, basicParams);
            params = angular.extend(params, arrangeParams());
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                function (data) {
                    data.fatherParams = params;
                    deferred.resolve(data);
                },
                function (data) {
                    data.fatherParams = params;
                    deferred.reject(data);
                    $modalInstance.dismiss();
                }
            );
            return deferred.promise;
        }

        /**
         * [arrangeParams description]
         * @return  {[type]}  [return description]
         */
        function arrangeParams() {
            var params = {
                ToMy: false,
                Paper: [],
                Web: [],
                App: [],
                MlfApp: [],
                WeChat: [],
                WeiBo: [],
                tiktok: [],
                baijiahao: [],
                TouTiao: [],
                kuaibao: [],
                kuaishou: [],
            };
            angular.forEach($scope.data.selectedChannel, function (value, key) {
                if (value.key == 'iwo') {
                    // tak
                    params.ToMy = true;
                } else {
                    params[value.type].push(value.id);
                }
            });
            for (var i in params) {
                if (angular.isArray(params[i])) {
                    params[i] = params[i] + '';
                }
            }
            params.MicroBlog = params.WeiBo;
            if (params.MicroBlog.length) {
                params.microblogDocType = $scope.data.selectedWeiboType;
            }
            delete params.WeiBo;
            return params;
        }

        /**
         * [navToRight description] 导航栏右移
         * @return  {[type]}  [return description]
         */
        $scope.navToRight = function () {
            if ($scope.status.isNavMove) {
                return;
            }
            $scope.status.isNavMove = true;
            if ($scope.status.accessibleChannel - $scope.status.rightCount < 10) {
                $scope.status.isNavMove = false;
                return;
            }

            var currentMarginLeft = $scope.navStyle['margin-left'];
            var nextMarginLeft = parseInt(currentMarginLeft.replace('px', '')) - 50 + 'px';
            $scope.navStyle['margin-left'] = nextMarginLeft;
            $scope.status.rightCount++;
            $scope.status.isNavMove = false;
        };

        /**
         * [navToLeft description] 导航栏左移
         * @return  {[type]}  [return description]
         */
        $scope.navToLeft = function () {
            if ($scope.status.isNavMove) {
                return;
            }
            $scope.status.isNavMove = true;
            if ($scope.status.rightCount === 0) {
                $scope.status.isNavMove = false;
                return;
            }

            var currentMarginLeft = $scope.navStyle['margin-left'];
            var nextMarginLeft = parseInt(currentMarginLeft.replace('px', '')) + 50 + 'px';
            $scope.navStyle['margin-left'] = nextMarginLeft;
            $scope.status.rightCount--;
            $scope.status.isNavMove = false;
        };
    },
]);
